module.exports = __webpack_public_path__ + "img/DW365-213.d481cbaa.jpg";